module.exports = __webpack_public_path__ + "img/imagen6.1145df23.png";